<div class="content-page">
  <div class="container container-sm">
    <div class="page-header">
      <span class="section-tag">Help Center</span>
      <h1 class="page-title">How can we help?</h1>
      <p class="page-subtitle">Guides, tutorials, and answers to common questions.</p>
    </div>

    <div class="help-grid">
      <a routerLink="/api-docs" class="help-card">
        <div class="help-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
        </div>
        <h3>API Documentation</h3>
        <p>Integrate indexing into your application with our REST API.</p>
      </a>

      <a routerLink="/drip-guide" class="help-card">
        <div class="help-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        </div>
        <h3>Drip Mode Guide</h3>
        <p>Learn how to schedule submissions for natural indexing patterns.</p>
      </a>

      <a routerLink="/faq" class="help-card">
        <div class="help-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        </div>
        <h3>FAQ</h3>
        <p>Answers to common questions about indexing and our service.</p>
      </a>

      <a routerLink="/blog" class="help-card">
        <div class="help-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
        </div>
        <h3>Blog</h3>
        <p>SEO tips, indexing guides, and best practices.</p>
      </a>

      <a routerLink="/contact-us" class="help-card">
        <div class="help-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        </div>
        <h3>Contact Support</h3>
        <p>Get in touch with our team for personalized help.</p>
      </a>

      <a routerLink="/pricing" class="help-card">
        <div class="help-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
        </div>
        <h3>Pricing & Credits</h3>
        <p>Understand our credit-based pricing model.</p>
      </a>
    </div>

    <div class="support-card">
      <h2>Still need help?</h2>
      <p>Our support team typically responds within a few hours during business days.</p>
      <div class="support-actions">
        <a routerLink="/contact-us" class="btn btn-primary">Email support</a>
        <a href="mailto:support@quickindexingtool.com" class="btn btn-outline">support&#64;quickindexingtool.com</a>
      </div>
    </div>
  </div>
</div>
